import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
// import Store from 'store/store';
import s from 'components/bolt/neonHeader/neonHeader.sss';

export default class NeonHeader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			navMenuOpen: false
		};
		this.toggleNavMenu = this.toggleNavMenu.bind(this);
	}

	toggleNavMenu(newState) {
		if (typeof newState !== 'boolean') {
			newState = !this.state.navMenuOpen;
		}
		this.setState({ navMenuOpen: newState });
	}

	render(props, state) {
		let filmInfoURL = props.appData?.header?.filmInfoURL;
		if (filmInfoURL && !/https?:\/\//.test(filmInfoURL)) {
			filmInfoURL = `https://neonrated.com/film/${filmInfoURL}`;
		}

		const studioAssetsRoot = props.appData?.urls?.roots?.studio || '';

		return (
			<div class={s.wrapper} role="banner">
				<a href="https://neonrated.com/" class={s.brand} aria-label="home">
					<img src={`${studioAssetsRoot}/images/logo.svg`} height="32" alt="" />
				</a>
				<div class={s.right}>
					<button class={s.toggleMenu} aria-label="menu" aria-haspopup="menu" onClick={this.toggleNavMenu}>
						<img src={`${studioAssetsRoot}/images/menu.svg`} width="40" height="23" alt="" />
					</button>
					<div class={joinClasses(s.menuWrapper, state.navMenuOpen && s.open)}>
						<nav class={s.menu} role="navigation">
							{!!filmInfoURL && (<a href={filmInfoURL} target="_blank" class={s.navLink}><b>FILM INFO</b></a>)}
							{/* <a href="https://neonrated.com/films" class={s.navLink}>FILMS</a>
							<a href="https://shopneonrated.com/" target="_blank" class={s.navLink}>SHOP</a>
							<a href="https://cinema.neonrated.com/" class={s.navLink}>NEON&nbsp;CINEMA</a>
							<a href="https://neonrated.com/sign-up" class={s.navLink}>SIGN UP</a> */}
						</nav>
					</div>
				</div>
			</div>
		);
	}
}